export const getPedestalQr = (str: string, separator: string) => {
  return str.split(separator).pop();
};
